import { PaginaCrud } from '../components/PaginaCrud'
import type { Inventario } from '../types'

export default function Inventario() {
  return (
    <PaginaCrud<Inventario>
      titulo="Inventario"
      recurso="inventario"
      llave="id"
      columnas={[
        { campo: 'sku', titulo: 'SKU' },
        { campo: 'productoNombre', titulo: 'Producto' },
        { campo: 'almacenNombre', titulo: 'Almacen' },
        { campo: 'ubicacionCodigo', titulo: 'Ubicacion', render: (i) => i.ubicacionCodigo || '-' },
        { campo: 'cantidad', titulo: 'Cantidad' },
        { campo: 'reservado', titulo: 'Reservado' },
        { campo: 'disponible', titulo: 'Disponible' },
        { campo: 'costoPromedio', titulo: 'Costo', render: (i) => i.costoPromedio ?? '-' },
      ]}
      campos={[
        { nombre: 'productoId', etiqueta: 'Producto ID', tipo: 'numero', requerido: true },
        { nombre: 'almacenId', etiqueta: 'Almacen ID', tipo: 'numero', requerido: true },
        { nombre: 'ubicacionId', etiqueta: 'Ubicacion ID', tipo: 'numero' },
        { nombre: 'loteId', etiqueta: 'Lote ID', tipo: 'numero' },
        { nombre: 'cantidad', etiqueta: 'Cantidad', tipo: 'decimal', requerido: true },
        { nombre: 'costoPromedio', etiqueta: 'Costo promedio', tipo: 'decimal' },
      ]}
      valorInicial={{ tenantId: 1, cantidad: 0, reservado: 0 }}
      puedeEditar={true}
    />
  )
}
